module.exports = __webpack_public_path__ + "img/50h50_povorotnoe.32af45f6.svg";